import { TnACounterDTO } from "../../models/tna/tna-counters/tna-counter-dto";
import { BaseApiService } from "../base";

export class EmployeesTnACountersApiService extends BaseApiService<TnACounterDTO, TnACounterDTO> {
  constructor() {
    super({
      servicePath: "/TnAData",
      loadItemsPath: "/GetEmployeesTnACounters",
    });
  }
}
